import { OrganizationMapper } from "../organization/organization.mapper";
import { Team } from "./team.model";
import { TeamLogoMapper } from "./team-logo/team-logo.mapper";

export class TeamMapper {
  public static map(data: any): Team {
    if (!data) {
      return;
    }

    return new Team(
      data.id,
      data.name,
      TeamLogoMapper.map(data.logo),
      OrganizationMapper.map(data.organization),
      data.organizationName,
      data.userCount,
    );
  }
}
